import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/users')({
  beforeLoad: ({ context }): void => {
    if (
      context.permissions.isReady &&
      !context.permissions.hasAnyPermission(['users:manage', 'users:access-read-only'])
    ) {
      throw redirect({ to: '/settings' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/settings/users/pages/users-page')),
});
